const emptyCartPage = () => {
  Cookies.remove("serviceCart", {
    sameSite: "none",
    secure: true,
  });
  Cookies.remove("serviceCartCheckout", {
    sameSite: "none",
    secure: true,
  });
  document.querySelector(".rte").innerHTML = `
  <div class="cartEmpty">
    <p>
      <b>Attention</b>: Your repair cart is empty.
    </p>
    <a class="button-primary" href="/pages/repair-catalog">Add an item</a>
  `;
};

const applyDiscount = (length, array) => {
  return new Promise((resolve, reject) => {
    array.sort((a, b) => a[1].cost - b[1].cost);
    const secondMostExpensive = Math.round(
      parseFloat(array[length - 2][1].cost)
    );
    const reduceByFiftyPercent = secondMostExpensive * 0.5;
    if (length == 2) {
      // Reduce second most expensive variant by 50%, do not discount most expensive variant.
      array[length - 2][1].cost = Math.round(
        parseFloat(secondMostExpensive - reduceByFiftyPercent)
      );
      array[length - 1][1].cost = Math.round(parseFloat(array[length - 1][1].cost));
    } else if (length > 2) {
      // Reduce the second most expensive variant by 50%.
      array[length - 2][1].cost = Math.round(
        parseFloat(secondMostExpensive - reduceByFiftyPercent)
      );

      // Reduce everything by 75%, except the second most and most expensive variants.
      for (let i = 0; i < array.length - 2; i++) {
        const reduceBySeventyFive =
          Math.round(parseFloat(array[i][1].cost)) * 0.75;
        array[i][1].cost = Math.round(
          parseFloat(array[i][1].cost - reduceBySeventyFive)
        );
      }
      array[length - 1][1].cost = Math.round(parseFloat(array[length - 1][1].cost));
    }
    resolve();
  });
};

// Discount discounted serviceCart that was passed in as an argument and return a new serviceCart with the variantList being discounted. 
function discount(serviceCart) {
  let discountedCart = {};
  return new Promise(async (resolve, reject) => {
    for (const editID in serviceCart) {
      // Add a new variantList and lineItemPrice for each list item in discountedCart
      if (editID != "checkoutData") {
        discountedCart[editID] = {
          variantList: {},
          lineItemPrice: 0,
        };

        const variantListArray = Object.entries(serviceCart[editID].variantList);
        const { length } = variantListArray;
        if (length === 0)
          reject(
            new Error(
              `variantListArray length should not be 0. Check the issue variants selected for: serviceCart with editID: ${editID}`
            )
          );
          // No discounts applied.
          if (length == 1) {
          variantListArray[0][1].cost = Math.round(parseFloat(variantListArray[0][1].cost));
          discountedCart[editID].lineItemPrice = Math.round(
            parseFloat(variantListArray[0][1].cost * serviceCart[editID].quantity)
          );
          discountedCart[editID].variantList[variantListArray[0][0]] =
            variantListArray[0][1];
        }
        if (length >= 2) {
          await applyDiscount(length, variantListArray);

          // Get total sum of discounted variants.
          const totalSum = variantListArray.reduce((prev, next) => prev + next[1].cost, 0);
          discountedCart[editID].lineItemPrice = Math.round(parseFloat(totalSum * serviceCart[editID].quantity));

          // Set discountedCart variantList cost to the new discounted costs. 
          for (let i = 0; i < variantListArray.length; i++) {
            discountedCart[editID].variantList[variantListArray[i][0]] = variantListArray[i][1];
          }
        }

        // This is copying the existing serviceCart properties and values to the newServiceCart.
        for (const [key, value] of Object.entries(serviceCart[editID])) {
          if (key !== "variantList" && key !== "lineItemPrice") {
            discountedCart[editID][key] = serviceCart[editID][key];
          }
        }
      }
    }
    resolve(discountedCart);
  });
}

let originalCart = Cookies.get("serviceCart");

if (typeof originalCart == "undefined") {
  emptyCartPage();
} else {
  originalCart = JSON.parse(Cookies.get("serviceCart"));
  if (Object.keys(originalCart).length == 0) emptyCartPage();

  let cart = new RepairCart(originalCart);
  cart.discountedCart = JSON.parse(Cookies.get("serviceCart"));
  discount(cart.discountedCart)
		.then((discountedCart) => {
			if (!isEmpty(discountedCart)) {
				for (const editID in discountedCart) {
          // Create product list item
					const listItem = document.createElement("li");
					listItem.style.border = "1px solid #000";
          listItem.setAttribute("data-weight", discountedCart[editID].weight);
          listItem.innerHTML = `
                      <img src=${discountedCart[editID].featuredImage}/>
                    <a class="uk-accordion-title" href="#">${discountedCart[editID].productTitle}</a>
                    <div class="uk-accordion-content">
                          <p style="text-align: center">
                              <b>Selected Issues and their estimated prices</b>
                          </p>
                        <ul id="${editID}">
                        </ul>
                    </div>

                    <div>
                          <a name="edit-variant-button" data-edit-button-editId='${editID}' href="#">Edit Issues</a> | 
                          <a href="#" onclick="removeDevice('${editID}')">Remove Device</a> |
                          <label>Qty:</label>
                          <input data-editid='${editID}' name="qty" type="number" min="1" value='${discountedCart[editID].quantity}'/> 
                    </div>`;

          document.getElementById("cart-of-devices").appendChild(listItem);

					for (const variant in discountedCart[editID].variantList) {
						const issueButton = document.createElement("span");
						issueButton.className = "issue-buttons";
						issueButton.setAttribute("data-id", variant);
            issueButton.innerHTML = `${discountedCart[editID].variantList[variant].title} ~ $${discountedCart[editID].variantList[variant].cost} <span name="removeVariant" data-span-variant-id="${variant}" data-span-edit-id="${editID}" uk-icon="icon: trash"></span>`;
            document.getElementById(editID).appendChild(issueButton);
					}
				}
        cart.discountedCart = discountedCart;
        Promise.resolve();
			} else {
                emptyCartPage();
			}
    }).then(() => {
      const editVariantButtons = document.querySelectorAll("[name='edit-variant-button']");
      for (let anchorTag of editVariantButtons) {
        const editID = anchorTag.getAttribute("data-edit-button-editId");
        anchorTag.addEventListener("click", function() {
          updateCookieQty();
          return window.location.href = `/pages/repair-service-issues?p=${cart.serviceCart[editID].productHandle}&edit=${editID}`;
		});
}

      const qtyInputs = document.querySelectorAll("[name='qty']");

      // Create an event listener which manages what happens when a qty input is changed.
      for (let input of qtyInputs) {
        if(isNaN(parseFloat(input.value)) || parseFloat(input.value) < 1) invalidInput(input);

        input.addEventListener("change", function() {
          try {
            const qtyValue = parseFloat(input.value);
            const editID = input.getAttribute("data-editid");
            if (isNaN(qtyValue) || parseFloat(qtyValue) < 1) throw input;
            validInput(input);
            let newServiceCart = cart.discountedCart;
            console.info("newServiceCart", newServiceCart);
            newServiceCart[editID].lineItemPrice = cart.calcLineItemCost(editID, qtyValue);
            newServiceCart[editID].quantity = qtyValue;
            Cookies.set("serviceCart", JSON.stringify(newServiceCart), {
              sameSite: "none",
              secure: true
            });
            cart.discountedCart = newServiceCart;
            document.getElementById("estimate-total").innerText = cart.estimateTotal;
            document.getElementById("sendAmount").innerText = cart.totalQty;
          } catch (input) {
            invalidInput(input);
						}
        });
					}
      document.getElementById("sendAmount").innerText = cart.totalQty;
      document.getElementById("estimate-total").innerText = cart.estimateTotal;

      // Create an event listener for every time the remove variant span is clicked.
      const removeIssueSpan = document.querySelectorAll("[name='removeVariant']");

      for (let span of removeIssueSpan) {
        span.addEventListener("click", function() {
          const variantID = span.getAttribute("data-span-variant-id");
          const editID = span.getAttribute("data-span-edit-id");
          const qtyInput = document.querySelector(`input[data-editid="${editID}"]`);
          removeIssue(editID, variantID, qtyInput.value);
        });
					}
    }).catch((error) => {
      console.error(error);
      emptyCartPage();
    });

    const addAnotherDeviceBtn = document.getElementById("add-another-device-button");
    addAnotherDeviceBtn.addEventListener("click", function() {
          updateCookieQty();
          return window.location.href = "/pages/repair-service-checkout";
    });

    // For each line item save the current qty.
    const updateCookieQty = () => {
      const tempCookie = cart.serviceCart;
      const qtyInputs = document.querySelectorAll("[name='qty']");
      for (let input of qtyInputs) {
        const qtyValue = parseFloat(input.value);
        const editID = input.getAttribute("data-editid");
        tempCookie[editID].quantity = qtyValue;
      }
      Cookies.set("serviceCart", JSON.stringify(tempCookie), {
        sameSite: "none",
        secure: true
	});
    };

document
	.getElementById("checkout-button")
	.addEventListener("click", (event) => {
		event.preventDefault();
    if(event.target.getAttribute('disabled') === 'disabled') return;
      try {
        const checkoutCookie = {
          totalWeight: cart.weight,
          variantList: cart.arrayVariantList,
			uuid: uuidv4(),
          productIdList: cart.arrayProductIdList,
		};
		
        updateCookieQty();
        const updatedQtyOriginal = JSON.parse(Cookies.get("serviceCart"));

        Cookies.set("serviceCartCheckout", JSON.stringify(checkoutCookie), {
			sameSite: "none",
			secure: true,
		});

        Cookies.set("serviceCart", JSON.stringify(updatedQtyOriginal), {
          sameSite: "none",
          secure: true
	});

        return (window.location.href = "/pages/repair-service-checkout");
      } catch (err) {
        invalidInput();
			}
    });
}


  // This method should hide the sending in message and only show the error message.
  const invalidInput = (input) => {
    if(input.value < 1){
      input.value = 1;
      return;
    }

    if (input.value == 0) {
      const sendingInMessage = document.getElementById("sendingInMessage");
      const qtyError = document.getElementById("qtyError");
      if (qtyError.hasAttribute("hidden")) qtyError.toggleAttribute("hidden");
      if (!sendingInMessage.hasAttribute("hidden")) sendingInMessage.toggleAttribute("hidden");
    } else {
      console.log("invalid Input:", input);
      input.classList.toggle("invalidInput");

      const sendingInMessage = document.getElementById("sendingInMessage");
      const qtyError = document.getElementById("qtyError");
      if (qtyError.hasAttribute("hidden")) qtyError.toggleAttribute("hidden");
      if (!sendingInMessage.hasAttribute("hidden")) {
        sendingInMessage.toggleAttribute("hidden");
      }
    }
    document.getElementById('checkout-button').setAttribute("disabled","disabled");
  };


  const validInput = (input) => {
    const sendingInMessage = document.getElementById("sendingInMessage");
    const qtyError = document.getElementById("qtyError");

    // remove invalidInput class (just in case it was an invalid input previously.)
    input.classList.remove("invalidInput");
    document.getElementById('checkout-button').removeAttribute("disabled");

    if (!qtyError.hasAttribute("hidden")) qtyError.toggleAttribute("hidden");
    if (sendingInMessage.hasAttribute("hidden"))
      sendingInMessage.toggleAttribute("hidden");
  };